import { IVariant } from 'unleash-proxy-client';

export const getVariantValue = (variant: IVariant) => variant.payload?.value;

export const isTreatmentEnrolled = (variant: IVariant, treatment = '1') => getVariantValue(variant) === treatment;
